import { IUserProfile, IUserProfilePayload, ResourceResponse } from "../models/UserProfile";
import { makeRequest } from "../../../utils/helpers/helperMethods/makeRequest";
import { AppDispatch } from "../../../slices/store";
import { editCurrentUser, editUser } from "../../../slices/users/userManagementSlice";
import { scrollToTop } from "../../../utils/helpers/helperMethods/scrollToTop";

export class UserProfileService {
  private baseUrl = process.env.REACT_APP_INFINITYS_API || "";
  async fetchCurrentUser(): Promise<IUserProfile> {
    const res = await makeRequest(
      localStorage.getItem("AccessToken"), // note lower-case key
      `${this.baseUrl}/api/users/current-user`,
      "GET",
      null,
      ''
    );

    if (!res.ok) {
      const text = await res.text(); // capture server message (likely HTML)
      console.error("Failed to fetch user:", res.status, text);
      throw new Error(`Request failed: ${res.status}`);
    }
    const data = await res.json();
    return data;
  }

  async updateUserSetting(userId: number, type: number) {
    const endpoint = `${this.baseUrl}/api/users/update-user-settings/${userId}/${type}`;

    const response = await fetch(endpoint, {
      method: "PUT",
      headers: {
        "Authorization": `Bearer ${localStorage.getItem("AccessToken")}`,
        "Content-Type": "application/json"
      }
    });

    if (!response.ok) {
      throw new Error("Failed to update setting");
    }
  }

  async fetchUserProfilePicture(payload: IUserProfilePayload): Promise<ResourceResponse> {
    if (!payload.ReferenceId) return Promise.reject("User ID is required");
    const query = new URLSearchParams({
      Reference: String(payload.Reference),
      Type: String(payload.Type),
      ReferenceId: String(payload.ReferenceId),
    });

    const res = await makeRequest(
      localStorage.getItem("AccessToken"),
      `${this.baseUrl}/api/resources?${query.toString()}`,
      "GET",
      null,
      ""
    );

    if (!res.ok) {
      throw new Error(`Fetch profile picture failed: ${res.status}`);
    }
    return res.json();
  }

  async uploadUserProfilePicture(payload: IUserProfilePayload, file: File): Promise<any> {
    const queryParams = new URLSearchParams({
      Reference: payload.Reference.toString(),
      Type: payload.Type.toString(),
      ReferenceId: payload.ReferenceId.toString(),
    });

    const url = `${this.baseUrl}/api/resources?${queryParams.toString()}`;

    const res = await makeRequest(
      localStorage.getItem("AccessToken"),
      url,
      "POST",
      null, // no JSON data
      file  // file to upload
    );

    if (!res.ok) {
      const text = await res.text();
      throw new Error(text || `Upload failed: ${res.status}`);
    }

    return res.json();
  }
}

export const handleEditUser = (
  data: any,
  dispatch: AppDispatch,
  setIsLoading: any,
  addAlert: Function,
  shouldRedirect: boolean,
  navigate: Function,
  protectedResources: any,
  url: string,
  reqRequests: any,
  getClients: any,
): Promise<void> => {
  return new Promise((resolve, reject) => {
    const params = {
      user: data,
      accessToken: localStorage.getItem('AccessToken') || "",
      url: url,
      imageURL: "",
      selectedFile: null,

    }

    dispatch(editCurrentUser(params)).then((r: any) => {
      scrollToTop();
      if (r?.payload?.status === "success") {
        addAlert("User Edited Successfully", "success", true);
        resolve();
      } else {
        dispatch(getClients(reqRequests)).then((r: any) => {
          if (r.payload.succeeded) {
            setIsLoading(false);
            if (shouldRedirect) {
              navigate(-1);
            }
          }
        })
      }
    }).catch(e => {
      setIsLoading(false);
      addAlert("Customer Edit Failed", "failed", true);
      reject(e);
    });
  });

}